module.exports = function() {
  return new Worker(__webpack_public_path__ + "8968472c9c764a58ad37.worker.js");
};